const readAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

// Browsers apply EXIF orientation to naturalWidth/Height, matching the frame sharp crops in.
const naturalSize = (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () =>
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = () =>
      reject(new Error("That file could not be read as an image."));
    image.src = src;
  });

export default async function readImageFile(source) {
  const dataUrl =
    typeof source === "string" ? source : await readAsDataUrl(source);

  return { dataUrl, imageSize: await naturalSize(dataUrl) };
}
